/**
 * Gets the maximum value of the given elements
 * Note: Math.[max|min] is part of ES3 and thus can be used directly
 */
export function max(...elements: number[]): number {
	return Math.max(...elements);
}

/**
 * Gets the minimum value of the given elements
 * Note: Math.[max|min] is part of ES3 and thus can be used directly
 */
export function min(...elements: number[]): number {
	return Math.min(...elements);
}
